import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SHARED_ENVIRONMENT } from '@cp/shared/environment/environment.token';
import { Environment } from '@cp/shared/environment/environment.interface';
import { SharedHttpService } from '../../shared/shared-http.service';
import { DashboardHttpPaths } from './dashboard-http.paths';
import {
  PayRatesHttpModel,
  PayRatesTouchlessHttpModel,
} from './dashboard-http.models';

@Injectable({
  providedIn: 'root',
})
export class DashboardHttpService extends SharedHttpService {
  public shiftsCount$ = this._http.get<number>(
    this._environment.apiEndpoint + DashboardHttpPaths.shiftsCount,
  );
  public payRatesTouchless$ = this._http.get<PayRatesTouchlessHttpModel>(
    this._environment.apiEndpoint + DashboardHttpPaths.payRates,
  );
  public payRates$ = this._http.get<PayRatesHttpModel>(
    this._environment.apiEndpoint + DashboardHttpPaths.payRates,
  );

  constructor(
    private _http: HttpClient,
    @Inject(SHARED_ENVIRONMENT)
    private _environment: Environment,
  ) {
    super();
  }
}
